import React from 'react';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { Link } from 'react-router-dom';

const Back = () => {
    return (
        <div className="mb-8 mt-4">
            <Link 
                to="/" 
                className="inline-flex items-center space-x-2 bg-white/70 backdrop-blur-md px-4 py-3 rounded-xl shadow-lg border border-white/30 text-gray-700 hover:bg-white/90 hover:shadow-xl transform hover:scale-105 transition-all duration-300 poppins font-medium"
            >
                <MdOutlineKeyboardBackspace className="w-5 h-5" />
                <span>Back to Menu</span>
            </Link>
        </div>
    )
}

export default Back
